<template>
  <div>
    Скачайте
    <a
      class="LKPublicationsDataCollectsForm__link"
      @click="$emit('download')"
    >excel шаблон</a>
    <template v-if="!hideUploadHint">
      <br>
      Для загрузки заполненного отчета в систему воспользуйтесь кнопкой "Загрузить из Excel"
      <br>
      <br>
      Внимание! При загрузке файла все введённые ранее в форме данные будут заменены данными из файла
    </template>
  </div>
</template>

<script>
export default {
  name: 'LKPublicationsFormdataDownloadTemplateLink',
  props: {
    hideUploadHint: Boolean,
  },
}
</script>
